<template>
  <article v-if="lecture" class="flex flex-col">
    <div class="mb-[120px] flex gap-[20px]">
      <div class="flex flex-col xl:w-3/4 2xl:w-4/5">
        <h1
          class="mb-[28px] text-[32px] font-medium leading-[38px]"
          v-text="lecture.title"
        />
        <CommonBlocksImageArticleBlock
          v-if="lecture.image"
          class="mb-[32px]"
          :published-at="lecture.published_at"
          :src="lecture.image.src"
        />
        <div v-if="correctSrc" class="mb-6 h-40 w-full md:h-136">
          <iframe
            v-lazy-load
            :src="correctSrc"
            width="100%"
            height="100%"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div v-else class="text-[32px] font-medium leading-[38px]">
          Видео не найдено.
        </div>
        <div class="page-body mb-[65px]" v-html="lecture.body" />
        <!-- <CommonMobileBannerBlock /> -->
        <ClientOnly>
          <div v-if="lecture.authors?.length" class="flex flex-col">
            <h3 class="mb-[36px] text-[24px] font-medium">Автор</h3>
            <div class="grid grid-flow-row gap-5">
              <CommonAuthorInfo
                v-for="author in lecture.authors"
                :key="author.id"
                :author="author"
              />
            </div>
          </div>
        </ClientOnly>
      </div>
      <CommonBlocksRightArticleBlock class="xl:w-1/4 2xl:w-1/5" />
    </div>

    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
definePageMeta({
  layout: 'marginless',
});

const route = useRoute();
const slug = route?.params?.slug;
const { lectureSlug } = useLecturesBySlug(slug);
const lecture = computed(() => lectureSlug?.data?.value);

const correctSrc = computed(() => {
  if (lecture.value?.video_code?.includes('https')) {
    return lecture.value.video_code;
  }
  return false;
});
const title = computed(() => lecture.value?.title || '');
const seo = computed(() => lecture.value?.seo || '');
const robots = ref('all');

if (seo.value) {
  const arr = [];
  if (seo.value.index === false) arr.push('noindex');
  if (seo.value.follow === false) arr.push('nofollow');
  if (seo.value.archive === false) arr.push('noarchive');
  if (arr.length > 0) {
    robots.value = arr.reduce((previousValue, currentValue) => {
      return `${previousValue}, ${currentValue}`;
    });
  }
}

useHead(
  computed(() => ({
    title: `${title.value ? `${title.value} |` : ''} Смотреть ${
      route.path.split('/').includes('films') ? 'фильмы' : 'видеолекции'
    } по истории РФ для школьников и студентов`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `${
          seo.value?.metadescription || seo.value?.metatitle || title.value
        }. Смотреть ${
          route.path.split('/').includes('films') ? 'фильмы' : 'видеолекции'
        } по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `${title.value}`,
      },
      {
        'http-equiv': 'Last-Modified',
        content: new Date(seo.value?.last_modified).toUTCString(),
      },
      {
        hid: 'robots',
        name: 'robots',
        content: robots.value,
      },
    ],
  })),
);
</script>
